import { useState, useEffect } from 'react';

function useCardStyles(publisher) {
    const [coverGradient, setCoverGradient] = useState('linear-gradient(135deg, #02024d, #0078FF)');
    const [logoGradient, setLogoGradient] = useState('linear-gradient(135deg, #0078FF, #00D7FF)');

    useEffect(() => {
        if (publisher.coverColors?.length >= 2) {
            setCoverGradient(
                `linear-gradient(135deg, ${publisher.coverColors[0]}, ${publisher.coverColors[1]})`
            );
        }
    }, [publisher.coverColors]);

    useEffect(() => {
        if (publisher.logoColors?.length >= 2) {
            setLogoGradient(
                `linear-gradient(135deg, ${publisher.logoColors[0]}, ${publisher.logoColors[1]})`
            );
        }
    }, [publisher.logoColors]);

    return {
        coverGradient,
        logoGradient,
    };
}

export default useCardStyles;
